module.exports = __webpack_public_path__ + "img/12_newYouth_lxs.136094e2.png";